/**
 * A Web Lock picks the one owning tab and is released automatically when the
 * tab closes or crashes; a `BroadcastChannel` on the same name carries owner
 * announcements and focus/takeover requests. A message and a lock grant can
 * arrive in either order.
 */

export const TAB_ID = crypto.randomUUID();

export const LOCKS_SUPPORTED =
  typeof navigator !== "undefined" && "locks" in navigator;

export const BROADCAST_SUPPORTED = typeof BroadcastChannel !== "undefined";

export type OwnershipMessage =
  | { type: "query-owner" }
  | { type: "owner-here"; tabId: string; since: number }
  | { type: "focus-request"; fromTabId: string }
  | { type: "takeover-request"; fromTabId: string }
  | { type: "takeover-granted"; toTabId: string }
  | { type: "takeover-refused"; toTabId: string; reason: string };

export const coordinationName = (
  principalKey: string,
  installationId: string,
): string => `brian.softphone.${principalKey}.${installationId}`;
